export default __webpack_public_path__ + "static/media/character4.062edd5a.png";